import * as React from "react";
import DashboardLayout from "../../layout/DashboardLayout/DashboardLayout";

const Resources = () => {
  return <DashboardLayout></DashboardLayout>;
};

export default Resources;
